// extracted by mini-css-extract-plugin
module.exports = {"tos_page":"TermsCondPage_tos_page__3x8Oe","lang_toggle_container":"TermsCondPage_lang_toggle_container__1SDvp"};